/*
<summary>
  This functional component "ProjectInfo" provides modal popup that shows project information.
  Developer:Pratiksha Sharma, Created Date:05-May-2026, Last Updated By: Pratiksha Sharma, Updated Date: 05-May-2026
</summary>
<returns>Returns JSX</returns>
*/

import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './project-info.css';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import infoCard from '../../../assets/Images/project-info-card.jpg';
interface IProps {
    version: string;
    modalClosed: () => void;
}

const ProjectInfo = (props: IProps) => {
    return (
        <Modal
            show={true}
            centered
            onHide={props.modalClosed}
            dialogClassName="project-info-popup"
        >
            <Modal.Body>
                <img src={infoCard} alt="logout" className="img-fluid" />
                <div className="text-center px-4 pb-4">
                    <h3 className="mb-0">
                        {props.version ? ` v${props.version}` : <FormattedMessage id="version_not_available" />}
                    </h3>
                    <p className='text-xs text-muted mb-3'><FormattedMessage id="project_info_description" /></p>
                    <p className="small">&copy; 2026 DID Innovate Hub. All rights reserved.</p>

                    {/* <Button
                        variant="btn btn-dark btn-sm"
                        onClick={props.modalClosed}
                        className="btnOkSize"
                    >
                        <FormattedMessage id="cancel" />
                    </Button> */}
                </div>

            </Modal.Body>
        </Modal>
    );
};

export default observer(ProjectInfo);
